<template>
    <div
        :class="[
            { 'delete-show-modal': [steps.copyFeedUrl, steps.delete, steps.success].includes(step) },
            { 'cancel-modal': step === steps.questions },
            'modal',
        ]"
    >
        <div
            :class="[
                { 'full-width-content': [steps.copyFeedUrl].includes(step) },
                { 'medium-content': step === steps.delete },
                { 'cancel-modal-content-start': step === steps.questionsStart },
                { 'cancel-modal-content': step === steps.questions },
                { 'small-content': step === steps.success },
                'modal-content',
            ]"
        >
            <base-modal-close
                v-if="! [steps.questionsStart, steps.questions].includes(step)"
                @close-modal="closeModal"
            />
            <transition
                name="fade"
                mode="out-in"
            >
                <copy-feed-url
                    v-if="step === steps.copyFeedUrl"
                    :show="show"
                    @change-step-prev="closeModal"
                    @change-step-next="changeStep(steps.delete)"
                >
                    <p class="step-title">
                        Before you delete Show.
                    </p>
                    <p class="step-description">
                        Make sure to copy your current Fusebox RSS feed as you’ll most likely need it import your podcast to a new host before deleting Show.
                    </p>
                </copy-feed-url>
                <step-delete
                    v-if="step === steps.delete"
                    :show="show"
                    :price-ids="priceIds"
                    @change-step-prev="closeModal"
                    @change-step-next="startOffboarding"
                />
                <cancel-start
                    v-if="step === steps.questionsStart"
                    @change-step-next="changeStep(steps.questions)"
                    @finish="finishWithoutOffboarding"
                />
                <question
                    v-if="step === steps.questions"
                    :shows-count="proShowsCount"
                    :show-info="showInfo"
                    @finish="finishAfterOffboarding"
                 />
                 <last-step
                    v-if="step === steps.success"
                    :success-type="successType"
                    @close="closeModal"
                    @redirect="closeModalAndRedirect"
                 />
           </transition>
        </div>
    </div>
</template>

<script>
import { chain } from 'lodash';
import CopyFeedUrl from '@/components/Shows/CopyFeedUrl';
import StepDelete from './StepDelete';
import CancelStart from './Offboarding/CancelStart';
import Question from './Offboarding/Question';
import LastStep from './LastStep';
import {
    mapState,
    mapMutations,
} from 'vuex';
import { steps } from '@/utils/config/deleteShowModal';

export default {
    components: {
        CopyFeedUrl,
        StepDelete,
        CancelStart,
        Question,
        LastStep,
    },

    data: () => ({
        steps,
        subscriptionCancelled: false,
        successType: null,
        numberOfShows: null,
        newSubscriptionData: {},
        intervalProducts: {},
    }),

    computed: {
        ...mapState([
            'userSubscription',
        ]),

        ...mapState({
            shows: state => state.shows,
            data: state => state.UIState.deleteShowModal,
            step: state => state.UIState.deleteShowModal.step || 0,
            show: (state) => state.shows[state.UIState.deleteShowModal.showHash],
        }),

        /**
         * Returns count of pro shows.
         *
         * @returns {number} Count of pro shows.
         */
        proShowsCount() {
            return chain(this.shows || []).filter('isPro').value().length;
        },

        /**
         * Returns list of price IDs to decrement.
         *
         * @returns {string[]} List of price IDs.
         */
        priceIds() {
            return this.show?.plan.prices
                ? [this.show.plan.prices[this.userSubscription?.interval]?.id]
                : [];
        },
    },

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Closes modal
         *
         */
        closeModal() {
            this.changeUIState({
                deleteShowModal: {
                    visible: false,
                },
            });
        },

        /**
         * Starts the offboarding step.
         *
         * @param {object}  options                       Options.
         * @param {boolean} options.subscriptionCancelled Indicates whether subscription was cancelled or not.
         */
        startOffboarding({ subscriptionCancelled }) {
            this.subscriptionCancelled = subscriptionCancelled;
            this.changeStep(this.steps.questionsStart);
        },

        /**
         * Finishes deleting show without offboarding.
         */
        finishWithoutOffboarding() {
            this.successType = this.subscriptionCancelled ? 'subscriptionCancel' : 'showDelete';
            this.changeStep(this.steps.success);
        },

        /**
         * Finishes deleting show after offboarding.
         */
        finishAfterOffboarding() {
            this.successType = this.subscriptionCancelled ? 'subscriptionCancel' : 'offboardingComplete';
            this.changeStep(this.steps.success);
        },

        /**
         * Changes step.
         *
         * @param  {number} step Current step.
         */
        changeStep(step) {
            this.changeUIState({
                deleteShowModal: {
                    ...this.data,
                    step,
                },
            });
        },

        /**
         * Closes modal and redirects to show.
         */
        closeModalAndRedirect() {
            const showHash = this.show.hash;

            this.closeModal();

            this.$router.push(`/shows/${showHash}`);
        },
    },
};
</script>
